import ToastStore from 'components/UI/Toast/store';
import UploadStore from 'stores/upload/UploadStore';
import LegacyUpload from 'stores/upload/LegacyStore';

export default class AppStore
{
  toast = new ToastStore();
  upload = new UploadStore();
  legacyUpload = new LegacyUpload();
}